import React from 'react'
import MineTap from './MineTap'

const MineSweeper = () => {
  return (
    <>
      <MineTap/>
    </>
  )
}

export default MineSweeper